// extracted by mini-css-extract-plugin
export var quantityInput = "_q0-0";